export const defaultState = {
  placementReports: [],

  // Archived reports — lazy, paginated
  archivedDistricts: [],
  archivedPeriods: {}, // { [districtId]: [{ periodId, periodName, teachingLevelId, cnt }] }
  archivedPages: {}, // { [`${districtId}-${periodId}`]: { rows, total, page, pageSize } }

  placementReportDetails: [],
  changeList: [],
  prevPlacementReport: {},
  signatories: [],
  exitReasons: [],
  placementVacantPosts: [],
  banks: [],

  unsubmitted: [],
};
